import { Close } from '@mui/icons-material'
import { Box, Modal } from '@mui/material'
import CadastralPositionMovimentacao from 'pages/automation/cadastral-position-movimentacao'
import { useStyles } from './styles'

interface IModalCadastralPositionMovimentation {
  open: boolean
  setChangeState: () => void
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 'auto',
  minHeight: '300px',
  maxHeight: '800px',
  width: '90%',
  maxWidth: 800,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  padding: '1rem 1.5rem',
}

const ModalCadastralPositionMovimentation = ({ open, setChangeState }: IModalCadastralPositionMovimentation) => {
  const classes = useStyles()

  return (
    <Modal
      open={open}
      onClose={setChangeState}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box className={classes.header}>
          <h6>Enviar arquivo</h6>
          <Close
            className={classes.closeBtn}
            onClick={setChangeState}
          />
        </Box>
        <Box className={classes.container}>
          <CadastralPositionMovimentacao onClose={setChangeState} />
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalCadastralPositionMovimentation
